export type NotificationPriority = 'critical' | 'high' | 'medium' | 'low';

export type NotificationCategory =
  | 'meetings'
  | 'messages'
  | 'system'
  | 'marketing'
  | 'updates'
  | 'security';

export interface Notification {
  id: string;
  title: string;
  message: string;
  is_read: boolean;
  seen: boolean;
  read_at: string | null;
  sent_at: string;
  created_at: string;
  delivery_method: string;
  origin: string;
  type_id: string;
  user_id: string;
  data: Record<string, any>;
  priority?: NotificationPriority;
  category?: NotificationCategory;
}

export interface CategoryPreference {
  enabled: boolean;
  priority_threshold: NotificationPriority;
}

export interface NotificationPreferences {
  enabled: boolean;
  sound_enabled: boolean;
  dnd_enabled: boolean;
  dnd_start_time: string | null;
  dnd_end_time: string | null;
  dnd_weekends: boolean;
  categories: Record<NotificationCategory, CategoryPreference>;
  digest_enabled: boolean;
  digest_frequency: 'immediate' | 'hourly' | 'daily' | 'weekly';
  digest_time: string | null;
}

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  enabled: true,
  sound_enabled: false,
  dnd_enabled: false,
  dnd_start_time: '22:00',
  dnd_end_time: '08:00',
  dnd_weekends: true,
  categories: {
    meetings: { enabled: true, priority_threshold: 'low' },
    messages: { enabled: true, priority_threshold: 'low' },
    system: { enabled: true, priority_threshold: 'medium' },
    marketing: { enabled: false, priority_threshold: 'high' },
    updates: { enabled: true, priority_threshold: 'medium' },
    security: { enabled: true, priority_threshold: 'low' },
  },
  digest_enabled: false,
  digest_frequency: 'daily',
  digest_time: null,
};
